export const IconCardFront = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M3.315 4.348h17.468c1.263 0 2.315 1.078 2.21 2.37v10.563c0 1.293-1.052 2.371-2.315 2.371H3.315C2.052 19.652 1 18.574 1 17.281V6.719c0-1.293 1.052-2.371 2.315-2.371m17.363 13.58c.42 0 .736-.324.736-.647V6.719c0-.323-.315-.647-.736-.647H3.315c-.42 0-.737.324-.737.647V17.28c0 .323.316.647.737.647zM3.946 12.97h8.63c.21 0 .525.215.525.539 0 .323-.21.539-.526.539H3.946c-.315 0-.526-.216-.526-.54 0-.322.21-.538.526-.538m6.104 2.802H4.052c-.316 0-.526.216-.526.539s.21.539.526.539h6.103c.316 0 .526-.216.526-.539s-.316-.539-.631-.539m5.787-2.802h4.104c.316 0 .526.215.526.539v2.802c0 .323-.21.539-.526.539h-4.104c-.316 0-.526-.216-.526-.539v-2.802c0-.324.21-.54.526-.54m.421 2.802h3.052v-1.724h-3.052z"
        clipRule="evenodd"
      />
    </svg>
  );
};
